import {
    GET_TARIFF_RATES,
    GET_TARIFF_RATES_SUCCESS,
    GET_TARIFF_RATES_FAILURE,
    GET_TARIFF_RATES_BY_HEAD,
    GET_TARIFF_RATES_BY_HEAD_SUCCESS,
    GET_TARIFF_RATES_BY_HEAD_FAILURE,
    GET_TARIFF_RATE_DETAILS,
    GET_TARIFF_RATE_DETAILS_SUCCESS,
    GET_TARIFF_RATE_DETAILS_FAILURE,
    CREATE_TARIFF_RATE,
    CREATE_TARIFF_RATE_SUCCESS,
    CREATE_TARIFF_RATE_FAILURE,
    UPDATE_TARIFF_RATE,
    UPDATE_TARIFF_RATE_SUCCESS,
    UPDATE_TARIFF_RATE_FAILURE,
    UPDATE_TARIFF_RATE_STATUS,
    UPDATE_TARIFF_RATE_STATUS_SUCCESS,
    UPDATE_TARIFF_RATE_STATUS_FAILURE,
    DELETE_TARIFF_RATE,
    DELETE_TARIFF_RATE_SUCCESS,
    DELETE_TARIFF_RATE_FAILURE
} from '../../../actions/index.types';

const initialState = {
    // List
    tariffRatesData: [],
    tariffRatesPagination: null,
    loading: false,
    error: null,

    // List By Head
    tariffRatesByHeadData: [],
    loadingByHead: false,
    errorByHead: null,

    // Details
    tariffRateDetails: null,
    detailsLoading: false,
    detailsError: null,

    // Create
    createLoading: false,
    createError: null,
    createSuccess: false,

    // Update
    updateLoading: false,
    updateError: null,
    updateSuccess: false,

    // Status Update
    statusLoading: false,
    statusError: null,
    statusSuccess: false,

    // Delete
    deleteLoading: false,
    deleteError: null,
    deleteSuccess: false
};

const TariffRateReducer = (state = initialState, action) => {
    switch (action.type) {
        // Get All Tariff Rates
        case GET_TARIFF_RATES:
            return {
                ...state,
                loading: true,
                error: null
            };
        case GET_TARIFF_RATES_SUCCESS:
            return {
                ...state,
                loading: false,
                tariffRatesData: action.data?.data || [],
                tariffRatesPagination: action.data?.meta?.pagination || null,
                error: null
            };
        case GET_TARIFF_RATES_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.data
            };

        // Get Tariff Rates By Head
        case GET_TARIFF_RATES_BY_HEAD:
            return {
                ...state,
                loadingByHead: true,
                errorByHead: null
            };
        case GET_TARIFF_RATES_BY_HEAD_SUCCESS:
            return {
                ...state,
                loadingByHead: false,
                tariffRatesByHeadData: action.data || [],
                errorByHead: null
            };
        case GET_TARIFF_RATES_BY_HEAD_FAILURE:
            return {
                ...state,
                loadingByHead: false,
                errorByHead: action.data
            };

        // Get Tariff Rate Details
        case GET_TARIFF_RATE_DETAILS:
            return {
                ...state,
                detailsLoading: true,
                detailsError: null
            };
        case GET_TARIFF_RATE_DETAILS_SUCCESS:
            return {
                ...state,
                detailsLoading: false,
                tariffRateDetails: action.data,
                detailsError: null
            };
        case GET_TARIFF_RATE_DETAILS_FAILURE:
            return {
                ...state,
                detailsLoading: false,
                detailsError: action.data
            };

        // Create Tariff Rate
        case CREATE_TARIFF_RATE:
            return {
                ...state,
                createLoading: true,
                createError: null,
                createSuccess: false
            };
        case CREATE_TARIFF_RATE_SUCCESS:
            return {
                ...state,
                createLoading: false,
                createSuccess: true,
                createError: null
            };
        case CREATE_TARIFF_RATE_FAILURE:
            return {
                ...state,
                createLoading: false,
                createError: action.data,
                createSuccess: false
            };

        // Update Tariff Rate
        case UPDATE_TARIFF_RATE:
            return {
                ...state,
                updateLoading: true,
                updateError: null,
                updateSuccess: false
            };
        case UPDATE_TARIFF_RATE_SUCCESS:
            return {
                ...state,
                updateLoading: false,
                updateSuccess: true,
                updateError: null
            };
        case UPDATE_TARIFF_RATE_FAILURE:
            return {
                ...state,
                updateLoading: false,
                updateError: action.data,
                updateSuccess: false
            };

        // Update Tariff Rate Status
        case UPDATE_TARIFF_RATE_STATUS:
            return {
                ...state,
                statusLoading: true,
                statusError: null,
                statusSuccess: false
            };
        case UPDATE_TARIFF_RATE_STATUS_SUCCESS:
            return {
                ...state,
                statusLoading: false,
                statusSuccess: true,
                statusError: null
            };
        case UPDATE_TARIFF_RATE_STATUS_FAILURE:
            return {
                ...state,
                statusLoading: false,
                statusError: action.data,
                statusSuccess: false
            };

        // Delete Tariff Rate
        case DELETE_TARIFF_RATE:
            return {
                ...state,
                deleteLoading: true,
                deleteError: null,
                deleteSuccess: false
            };
        case DELETE_TARIFF_RATE_SUCCESS:
            return {
                ...state,
                deleteLoading: false,
                deleteSuccess: true,
                deleteError: null
            };
        case DELETE_TARIFF_RATE_FAILURE:
            return {
                ...state,
                deleteLoading: false,
                deleteError: action.data,
                deleteSuccess: false
            };

        default:
            return state;
    }
};

export default TariffRateReducer;
